import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/reports')({
  component: () => <div style={{ padding: '24px' }}>Отчеты — страница в разработке</div>,
})
